import { Component } from '@angular/core';
import {
    ParametersService,
    SubtitlesService,
    ZoneScheduleService,
    ZonesService
} from "../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'zone-schedule-settings',
    templateUrl: './zone-schedule-settings.component.html',
    styleUrls: ['./zone-schedule-settings.component.scss']
})
export class ZoneScheduleSettingsComponent {
    firstDeleteHover: number = -1;
    firstAddHover: boolean = false;
    secondDeleteHover: number = -1;
    secondAddHover: boolean = false;

    constructor(
        private parameters: ParametersService,
        private $state: StateService,
        public subtitles: SubtitlesService,
        public zones: ZonesService,
        public zoneSchedule: ZoneScheduleService,
    ) {
    }
    ngOnInit() {
        if (this.zones.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }

        this.zones.setOverflow();
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }
}
